import React from 'react';

const FileInput = props => {
    const { onChange, label, name } = props;
    return (
        <div>
            <label>{ label ? label : 'Upload file'}</label>
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text">Upload</span>
                </div>
                <div className="custom-file">
                    <input type="file" className="custom-file-input" id="inputGroupFile01" onChange={onChange}/>
                    <label className="custom-file-label" htmlFor="inputGroupFile01">{name ? name : 'Choose file'}</label>
                </div>
            </div>
        </div>
    );
};

export default FileInput;
